var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "sk-console", class: { show: true } }, [
    _c(
      "div",
      { staticClass: "button-wrapper", on: { click: _vm.handleClick } },
      [
        _vm._v("\n    " + _vm._s(_vm.text) + "\n    "),
        _c("a", { attrs: { href: "javascript:;" } }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }